export default __webpack_public_path__ + "static/media/oxblock_logo.043bc86c.png";